import type { GetAllPeopleParams, GetPeopleParams } from './people.types';

/**
 * Kept out of `people.store` so the two stores can invalidate each other's data without
 * importing each other: a seat change invalidates subscriptions, and a plan change
 * invalidates people — one webhook writes both sides.
 */
export const peopleKeys = {
  all: ['people'] as const,
  list: (params: GetPeopleParams) => [...peopleKeys.all, 'list', params] as const,
  allList: (params: GetAllPeopleParams) => [...peopleKeys.all, 'all', params] as const,
  byIds: (ids: string[]) => [...peopleKeys.all, 'by-ids', [...ids].sort()] as const,
  detail: (id: string) => [...peopleKeys.all, 'detail', id] as const,
  me: () => [...peopleKeys.all, 'me'] as const,
};
